import React from "react";
import { View, Text } from "react-native";
import SmallCard from "../../../Compoents/Cards/SmallCards";
import { maxWidthContainer } from "../../../Constants/Sizes";
const data = [
  {
    title: "AI-Driven Digital Intelligence",
    description:
      "We embed **AI** into your business to **automate decisions**, **uncover patterns**, **forecast demand**, and **eliminate guesswork** across every operation.",
    icon: "🤖",
    iconBackgroundColor: "#E4D8FF",
    iconColor: "#7C3AED",
    buttonText: "LEARN",
  },
  {
    title: "IoT & Real-Time System Integration",
    description:
      "Connect **devices**, **sensors**, **machines**, and **operational tools** into one intelligent ecosystem with **live monitoring** and **automated actions**.",
    icon: "📡",
    iconBackgroundColor: "#FFEAC0",
    iconColor: "#F59E0B",
    buttonText: "LEARN",
  },
  {
    title: "Mobile-First Digital Experience",
    description:
      "Designs built for **modern users** — **fast**, **intuitive**, **responsive**, and accessible across **web, iOS, and Android** with seamless cross-platform UX.",
    icon: "📱",
    iconBackgroundColor: "#FFD8C8",
    iconColor: "#F97316",
    buttonText: "LEARN",
  },
  {
    title: "Cloud Architecture & Scalability",
    description:
      "We engineer **cloud systems** that **scale effortlessly**, ensuring **speed**, **reliability**, and **zero downtime** as your business grows.",
    icon: "☁️",
    iconBackgroundColor: "#D8F5CC",
    iconColor: "#22C55E",
    buttonText: "LEARN",
  },
  {
    title: "Automation & Workflow Intelligence",
    description:
      "Replace **manual, repetitive tasks** with **intelligent automation** that **optimizes performance** and ensures **consistency** across departments.",
    icon: "⚙️",
    iconBackgroundColor: "#DDEAFF",
    iconColor: "#3B82F6",
    buttonText: "LEARN",
  },
  {
    title: "Enterprise Integrations & APIs",
    description:
      "Your systems will finally **talk to each other** — we build **secure APIs** and integrations that **unify operations** and **eliminate data silos**.",
    icon: "🔗",
    iconBackgroundColor: "#D1FAE5",
    iconColor: "#10B981",
    buttonText: "LEARN",
  },
  {
    title: "Cybersecurity & Data Protection",
    description:
      "End-to-end protection with **encryption**, **monitoring**, **compliance frameworks**, and **AI-assisted threat detection** to safeguard your business.",
    icon: "🔐",
    iconBackgroundColor: "#FFE0F2",
    iconColor: "#EC4899",
    buttonText: "LEARN",
  },
  {
    title: "User Experience & Digital Design",
    description:
      "Clean, modern, **human-centered design** that maximizes **usability**, **engagement**, and **clarity** across all digital touchpoints.",
    icon: "✨",
    iconBackgroundColor: "#FFE1D8",
    iconColor: "#F97373",
    buttonText: "LEARN",
  },
];

const OneStop = () => {
  const [highlightedIndex, setHighlightedIndex] = React.useState(null);

  return (
    <View style={{ marginVertical: 100 }}>
      {/* Heading */}
      <Text
        style={{
          fontSize: 48,
          fontWeight: "800",
          textAlign: "center",
          color: "#111827",
          marginBottom: 16,
          letterSpacing: -1,
        }}
      >
        The Spectrum of Expertise
      </Text>
      <Text
        style={{
          fontSize: 18,
          textAlign: "center",
          color: "#6B7280",
          marginBottom: 60,
          maxWidth: 900,
          marginHorizontal: "auto",
          lineHeight: 28,
        }}
      >
        The only partner you need to **engineer**, **optimize**, and **evolve** your entire digital
        ecosystem
      </Text>

      {/* Cards Container */}
      <View
        style={{
          flexDirection: "row",
          zIndex: 999,
          maxWidth: maxWidthContainer,
          marginHorizontal: "auto",
          flexWrap: "wrap",
          gap: 20,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {data.map((item, index) => (
          <SmallCard
            key={index}
            icon={<Text style={{ fontSize: 44 }}>{item.icon}</Text>}
            title={item.title}
            description={item.description}
            buttonText={item.buttonText}
            iconBackgroundColor={item.iconBackgroundColor}
            iconColor={item.iconColor}
            onButtonPress={() => console.log("Pressed:", item.title)}
          />
        ))}
      </View>
    </View>
  );
};
export default OneStop;
